// extracted by mini-css-extract-plugin
export default {"splashPage":"Header-module__splashPage--fsHAn","splashPositioner":"Header-module__splashPositioner--rEqQ5","regularPage":"Header-module__regularPage--e6ZlL"};